import { Helmet } from "react-helmet";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ImpactReport from "@/components/resources/ImpactReport";
import QuickNav from "@/components/layout/QuickNav";

const ImpactReportPage = () => {
  return (
    <>
      <Helmet>
        <title>Impact & Opportunity Report | StaffAbility</title>
        <meta
          name="description"
          content="Data-driven analysis of StaffAbility's potential impact on recidivism reduction and economic opportunities."
        />
      </Helmet>
      <Navbar />
      <main>
        <ImpactReport />
      </main>
      <QuickNav />
      <Footer />
    </>
  );
};

export default ImpactReportPage;